// src/pages/Success.js
import '../styles/success.css';
import { useEffect } from 'react';

function Success() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="success-page">
            <div className="success-card">
                <h1>🎉 Setup in Progress</h1>
                <p>
                    Your Fleetify account setup has been initiated successfully.
                </p>
                <p className="info-text">
                    You’ll receive a confirmation email shortly with next steps.
                    We’re preparing your dashboard - this process may take up to <strong>24 hours</strong>.
                </p>

                <div className="success-buttons">
                    <a href="/" className="btn btn-primary">Go to Dashboard</a>
                    <a href="/sales" className="btn btn-outline">Contact Support</a>
                </div>

                <img
                    src="/images/dashboard.gif"
                    alt="Fleetify Dashboard Preview"
                    className="success-preview"
                />

                <footer className="success-footer">
                    Need help? <a href="mailto:support@fiveguycarrentals.com">support@fiveguycarrentals.com</a>
                </footer>
            </div>
        </div>
    );
}

export default Success;
